import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';

//import { Provider } from 'react-redux';
//import store from './store';

//<Provider store={store}>

ReactDOM.render(
  (
    // Provide our store to the application
  
      <App />
   
  ),
  document.getElementById('root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js